/* eslint-disable react/prop-types */
import React from 'react'

export default function SuccessIcon(props) {
  return (
    <svg
      width={props?.size || '25'}
      height={props?.size || '25'}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#00C481" />
      <path
        d="M18.75 7.8125L10.1562 16.4062L6.25 12.5"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
